import { render } from "./salaryBonus.vue?vue&type=template&id=2554c182&scoped=true"
import script from "./salaryBonus.vue?vue&type=script&lang=js"
export * from "./salaryBonus.vue?vue&type=script&lang=js"

import "./salaryBonus.vue?vue&type=style&index=0&id=2554c182&lang=scss&scoped=true"
import "./salaryBonus.vue?vue&type=style&index=1&id=2554c182&lang=scss&scoped=true"
import "./salaryBonus.vue?vue&type=style&index=2&id=2554c182&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2554c182"]])

export default __exports__